export default __webpack_public_path__ + "static/media/christtheking.bd92c11a.jpg";